import service from '.';

//查询修改记录
export const queryChangeList = () => service.get(`/admin/kycHistoryList?limit=9999`);
